module.exports = __webpack_public_path__ + "img/formulario.a01fc6fc.jpg";